import { notification } from 'antd';

export const handleApiError = (error) => {
  const errorData = error.data || {
    scope: 'ERROR',
    errors: [{ message: error.message, code: 'UNKNOWN' }],
  };

  errorData.errors.forEach((err) => {
    notification.error({
      message: errorData.scope,
      description: err.message,
      key: err.code,
    });
  });
};
